var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.progressClass},[_c('div',{class:_vm.progressBarClass,style:(_vm.barStyle)}),_c('div',{staticClass:"progress__icon"},[_c('svg',[_c('use',{attrs:{"xlink:href":"#picture-success"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }